import { render, staticRenderFns } from "./PayeeInfoPreview.vue?vue&type=template&id=5d464ba8&scoped=true&"
import script from "./PayeeInfoPreview.vue?vue&type=script&lang=ts&"
export * from "./PayeeInfoPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PayeeInfoPreview.vue?vue&type=style&index=0&id=5d464ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d464ba8",
  null
  
)

export default component.exports